import { render } from "./icon-question.vue?vue&type=template&id=5fc2acd2"
import script from "./icon-question.vue?vue&type=script&lang=js"
export * from "./icon-question.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__